import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "c-loading js-lint-loading" };
const _hoisted_2 = {
    key: 0,
    class: "c-loading__wrapper"
};
const _hoisted_3 = { class: "c-loading__loader" };
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 1,
    class: "p-topLoading"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "p-topLoading__main" }, "AI", -1);
const _hoisted_8 = { class: "p-topLoading__sub" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'LintLoading',
    props: {
        loading: {},
        topUrl: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.loading.isCountDown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: _ctx.topUrl + '/images/common/icon-shuriken_b.png',
                                alt: ""
                            }, null, 8, _hoisted_4)
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("img", {
                            src: _ctx.topUrl + '/images/common/bg-loading.png',
                            alt: "",
                            class: "p-topLoading__border"
                        }, null, 8, _hoisted_6),
                        _hoisted_7,
                        _createElementVNode("span", _hoisted_8, "処理中:" + _toDisplayString(_ctx.loading.timer), 1),
                        _createElementVNode("button", {
                            class: "p-topLoading__cancel",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                        }, "キャンセル")
                    ]))
            ], 512)), [
                [_vShow, _ctx.loading.isPending]
            ]);
        };
    }
});
